import React from 'react'
import ReactDOM from 'react-dom'

import { ReactQueryClientProvider } from '@termly-web/common'

import Termly from 'termly-namespace'

import generateID from 'utils/generateID'
import { unblockByURLSubstring } from 'utils/unblockers'

import BlockedContent from 'components/BlockedContent'
import ConsentConfigProvider from 'components/ConsentConfigProvider'
import ResourceBlockerIntlProvider from 'components/ResourceBlockerIntlProvider'
import ThemeProvider from 'components/ThemeProvider'

const THEME_PROVIDER_STYLE = {
  height: '100%',
}

const iframeID = generateID('termly-iframe')


export default function createReplacement({ consentConfig, hostname, referenceNode, supportedLocales }) {
  const dom = document.createElement('div')

  dom.style.cssText = referenceNode.style.cssText
  dom.style.width = `${ referenceNode.offsetWidth }px`
  dom.style.height = `${ referenceNode.offsetHeight }px`
  dom.style.minHeight = '9rem'
  dom.style.setProperty('--termly-blocked-content-max-height', `${ referenceNode.height }px`)
  dom.style.setProperty('--termly-blocked-content-max-width', `${ referenceNode.width }px`)
  dom.style.display = 'flex'
  dom.style.flexDirection = 'column'
  dom.style.justifyContent = 'center'
  dom.style.overflow = 'hidden'
  dom.className = 'termly-blocked-content t-blocked-content-container'
  dom.dataset.blockedCategories = referenceNode.dataset.categories

  const id = iframeID.next().value
  dom.dataset.blockedIframeId = id
  referenceNode.dataset.termlyIframeId = id

  const handleAcceptClick = () => {
    dom.remove()

    Termly.addUnblockedDomain(hostname)

    unblockByURLSubstring(hostname, {
      isTemporary: true,
    })
  }

  // We wrap the invocation of displayPreferenceModal() in a function
  // because it most likely has not yet been created when this
  // component is rendered...it's a mess.
  const handleManagePrefsClick = () => {
    if ( !window.displayPreferenceModal ) {
      console.error('displayPreferenceModal() is not defined')
      return
    }

    window.displayPreferenceModal()
  }

  ReactDOM.render(
    <ReactQueryClientProvider>
      <ResourceBlockerIntlProvider
        supportedLocales={ supportedLocales }
      >
        <ConsentConfigProvider
          consentConfig={ consentConfig }
        >
          <ThemeProvider
            style={ THEME_PROVIDER_STYLE }
          >
            <BlockedContent
              handleAcceptClick={ handleAcceptClick }
              handleManagePrefsClick={ handleManagePrefsClick }
              site={ hostname }
            />
          </ThemeProvider>
        </ConsentConfigProvider>
      </ResourceBlockerIntlProvider>
    </ReactQueryClientProvider>,
    dom)

  return dom
}
